module.exports = __webpack_public_path__ + "img/Migration.0e83cee1.svg";